<template>
    <section style="width: 100%;">
        <app-container-loading :show="isLoading" :text="'Enviando notificação...'"></app-container-loading>
        <section class="create-companies__main-area">
            <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                <div style="display: flex; justify-content: space-between;">
                    <div class="column">
                        NOTIFICAÇÃO
                        <div class="content-column">
                            <div class="section-items">
                                <div>
                                    <div style="display: flex; justify-content: space-between; align-items: center;">
                                        <div>Título*</div>
                                        <span :style="{ color: inputLengthColor('title') }">{{ form.title.length }}</span>
                                    </div>
                                    <input type="text" class="input input-config"
                                        v-model="form.title" style="text-transform: none;">
                                </div>
                            </div>
                            <div class="section-items">
                                <div>
                                    <div style="display: flex; justify-content: space-between; align-items: center;">
                                        <div>Descrição</div>
                                        <span :style="{ color: inputLengthColor('description') }">{{ form.description.length }}</span>
                                    </div>
                                    <input type="text" class="input input-config" style="text-transform: none;"
                                        v-model="form.description">
                                </div>
                            </div>
                            <div class="section-items">
                                <div>
                                    <div>Tópico*</div>
                                    <app-select :downIcon="true"  class="input input-config" style="margin-bottom: 10px;" :items="getTopics" :popoverProps="{ verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start' }" @input="form.topic = $event">
                                        <input type="text" class="select readonly" style="margin-bottom: 0; border: none; padding: 0" readonly 
                                            :value="getTopic(form.topic) 
                                                ? getTopic(form.topic).text
                                                : 'Selecione'"/>
                                        <template slot="item" slot-scope="slotProps">
                                            <span>{{ slotProps.text }}</span>
                                        </template>
                                    </app-select>
                                </div>
                            </div>
                            <div class="section-items">
                                <div style="margin-right: 15px;">
                                    <div>ID da notificação</div>
                                    <input type="text" class="input input-config"
                                        v-model="form.categoryId">
                                </div>
                                <div>
                                    <div>TTL (android)</div>
                                    <input type="text" class="input input-config"
                                        v-model="form.ttl">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div style="float:right; width: 200px;">
                        <a href="javascript:void(0)" class="btn button-gradient" style="float: right"
                            @click="submit()">
                            Enviar notificação
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ZepplinPushNotificationAPI from '../../../api/zepplin/push-notification'
export default {
    props: ['user'],
    data() {
        return {
            isLoading: false,
            form: {
                title: '',
                description: '',
                categoryId: null,
                ttl: null,
                topic: null
            },
            topics: [{
                value: 'zepplin',
                text: 'Todos registrados e não registrados'
            }]
        }
    },
    computed: {
        ...mapState('auth', ['zepplinMasterToken']),
        getTopics() {
            return this.topics
        }     
    },
    methods: {
        ...mapActions("toast", ["showToast", "showError"]),
        getTopic(topic) {
            return this.topics.find(_topic => _topic.value === topic)
        },

        inputLengthColor(type) {
            if(typeof(this.form[type]) !== 'string') return
            const length = this.form[type].length

            let neutralLength = 0
            let suggestedLength = type === 'description' ? 107 : 37
            let normalLength = type === 'description' ? 235 : 84
            if(length === neutralLength) return
            else if(length <= suggestedLength) return 'green'
            else if(length <= normalLength) return 'orange'
            else return 'red' 
        },

        validateForm(form) {
            const messages = []
            const defaultMessage = 'É necessário informar'
            if(!form.title) messages.push(`${defaultMessage} título.`)
            if(!form.topic) messages.push(`${defaultMessage} tópico.`)
            return messages
        },

        async submit() {
            const errorMessages = this.validateForm(this.form)
            errorMessages.forEach(errorMessage => {
                this.showError(errorMessage)
            })
            if(errorMessages.length) return 
            this.isLoading = true
            try {
                const form = this.handleForm(this.form)
                await ZepplinPushNotificationAPI.sendNotificationByTopic(this.form.topic, form, { ttl: form.ttl, masterToken: this.zepplinMasterToken })
                this.showToast({ type: 'success', message: 'Notificação enviada com sucesso!' })
            }
            catch(err) {
                console.error(err)
                this.showError('Não foi possível enviar notificação.')
            }
            this.isLoading = false
        },

        handleForm({ categoryId, title, description }) {
            return {
                categoryId: categoryId || undefined,
                title,
                description
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    input {
        margin-bottom: 10px;
    }

    .input-config {
        border-bottom: 1px solid #525662;
        width: 100%;
    }

    .column {
        width: 100%;
        font-weight: 600;
    }

    .content-column {
        margin-top: 20px;
        width: 100%;

        div {
            width: 100%;
        }
    }

    .field {
        display: flex;
        justify-content: space-between;
    }

    .section-items {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .create-companies__main-area {
        width: 100%;
        background-color: var(--bg-color--2);
        padding: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
</style>


